"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_VerificationResult = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Timing_1 = require("./RTTI_Timing");
var RTTI_date_1 = require("../Scalar/RTTI_date");
var RTTI_VerificationResult_PrimarySource_1 = require("./RTTI_VerificationResult_PrimarySource");
var RTTI_VerificationResult_Attestation_1 = require("./RTTI_VerificationResult_Attestation");
var RTTI_VerificationResult_Validator_1 = require("./RTTI_VerificationResult_Validator");
exports.RTTI_VerificationResult = t.recursion('IVerificationResult', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('VerificationResult')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            target: t.array(RTTI_Reference_1.RTTI_Reference),
            targetLocation: t.array(t.string),
            _targetLocation: t.array(RTTI_Element_1.RTTI_Element),
            need: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            status: RTTI_code_1.RTTI_code,
            _status: RTTI_Element_1.RTTI_Element,
            statusDate: RTTI_dateTime_1.RTTI_dateTime,
            _statusDate: RTTI_Element_1.RTTI_Element,
            validationType: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            validationProcess: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            frequency: RTTI_Timing_1.RTTI_Timing,
            lastPerformed: RTTI_dateTime_1.RTTI_dateTime,
            _lastPerformed: RTTI_Element_1.RTTI_Element,
            nextScheduled: RTTI_date_1.RTTI_date,
            _nextScheduled: RTTI_Element_1.RTTI_Element,
            failureAction: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            primarySource: t.array(RTTI_VerificationResult_PrimarySource_1.RTTI_VerificationResult_PrimarySource),
            attestation: RTTI_VerificationResult_Attestation_1.RTTI_VerificationResult_Attestation,
            validator: t.array(RTTI_VerificationResult_Validator_1.RTTI_VerificationResult_Validator)
        })
    ]);
});
//# sourceMappingURL=RTTI_VerificationResult.js.map